<template>
    <img
        v-if="colorMode === 'light'"
        :src="getIllustrationUrl(nameToLowerCase, 'light')"
        :alt="` illustration`"
        class="self-end"
    />
    <img
        v-else
        :src="getIllustrationUrl(nameToLowerCase, 'dark')"
        :alt="` illustration`"
        class="self-end"
    />
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
    name: 'IllustrationSvg',
    props: {
        illuName: {
            type: String,
            required: true,
        },
    },
    setup(props) {
        const store = useStore()

        const colorMode = computed(() => store.getters['ui/colorMode'])

        const nameToLowerCase = computed(() => props.illuName.toLowerCase())

        const getIllustrationUrl = (name: string, colorMode: string) => {
            if (colorMode) {
                return require(`@/assets/images/illustrations/${name}-${colorMode}.svg`)
            }
            return require(`@/assets/images/illustrations/${name}.svg`)
        }

        return {
            colorMode,
            nameToLowerCase,
            getIllustrationUrl,
        }
    },
})
</script>
